var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M57.167 24.4C51.007 14.72 41.993 9.146 32.5 9.146c-4.747 0-9.36 1.387-13.573 3.974-4.213 2.613-8 6.427-11.093 11.28-2.667 4.187-2.667 10.987 0 15.173 6.16 9.707 15.173 15.254 24.666 15.254 4.747 0 9.36-1.387 13.574-3.974 4.213-2.613 8-6.427 11.093-11.28 2.666-4.16 2.666-10.986 0-15.173M32.5 42.773A10.76 10.76 0 0 1 21.727 32 10.76 10.76 0 0 1 32.5 21.227 10.76 10.76 0 0 1 43.273 32 10.76 10.76 0 0 1 32.5 42.773"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M32.5 24.374c-4.187 0-7.6 3.413-7.6 7.626 0 4.187 3.413 7.6 7.6 7.6s7.627-3.413 7.627-7.6-3.44-7.626-7.627-7.626"
  })));
};
export default SvgEye;